import ContactSupportLink from '@root/contact-support/src/components/contact-support-link';
import LoginHeading from '@root/login/src/components/login-heading';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import RouteLink from '@root/core/src/components/route-link';
import checkmarkStroke from '@root/core/src/assets/checkmark-stroke.svg';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';
import { useLocation } from '@root/core/src/components/route';
export default function LoginEmailLinkSent({ module, basePath }) {
  const { trackClick } = useAnalytics([module, 'EMAIL_LOGIN_LINK_SENT']);
  const location = useLocation();
  const subtext = `We sent a link to ${location.state?.email ? `${location.state?.email}` : 'the email address you gave us'}. Check your email to continue.`;

  return (
    <div>
      <LoginHeading
        heading={'Check your email.'}
        icon={checkmarkStroke}
        subtext={subtext}
      />
      <RouteLink
        css={styles.link}
        onClick={() => trackClick('TRY_AGAIN')}
        to={`${basePath}/login/email`}
      >
        Didn’t get your link? Try again.
      </RouteLink>
      <div css={styles.support}>
        <ContactSupportLink />
      </div>
    </div>
  );
}

LoginEmailLinkSent.propTypes = {
  basePath: PropTypes.string.isRequired,
  module: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  link: {
    ...Theme.link(),
  },
  support: {
    marginTop: 20,
  },
});
